import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'

import { Nav } from '@js/components/Nav'

import { Slider } from '@js/components/Slider'

import '@js/components/liteYoutube.ts'
import '@js/components/liteVimeo.ts'
import commerce7CookieSync from '@js/components/commerce7CookieSync'
// import commerce7Observer from '@js/components/commerce7Observer'

// import '@js/components/commerce7/accountLink'

window.Alpine = Alpine

Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.plugin(collapse)

Alpine.data('slider', Slider)
Alpine.data('nav', Nav)

Alpine.start()
// commerce7Observer()

// Sync Commerce7 customerToken to domain-accessible cookie
commerce7CookieSync()
